import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { CONTEXTUAL_ENTITY_TYPE } from '@bingads-webui-campaign/recommendation-core';
import { withContextualAttributeTemplate } from '@bingads-webui-campaign/recommendation-contextual-attribute';

import template from './generated-from-column.pug';

export class GeneratedFromColumn extends ProjectionGridBaseColumn {
  constructor({ newI18n }) {
    super({
      name: 'GeneratedFrom',
      property: 'GeneratedFrom',
      title: newI18n.getString(_TL_('Generated From')),
      bodyClasses: ['grid-column-generateFrom', 'actionable'],
      colClasses: ['col-normalText'],
      type: 'string',
    });

    this.newI18n = newI18n;
  }

  template({
    value: {
      Opportunities,
    },
  }) {
    const opportunity = _.first(Opportunities);
    let generatedFrom;
    if (opportunity.GoalTypeCode === 'DestinationGoal') {
      generatedFrom = this.newI18n.getString(_TL_('Website URL from UET'));
    } else if (opportunity.GoalTypeCode === 'EventGoal') {
      generatedFrom = this.newI18n.getString(_TL_('URL sending Custom Events'));
    } else if (opportunity.GoalTypeCode === 'ClarityEventGoal') {
      generatedFrom = this.newI18n.getString(_TL_('Clicked Events from Clarity'));
    }

    let Urls;
    if (opportunity.GoalTypeCode === 'ClarityEventGoal') {
      Urls = generatedFrom;
    } else {
      Urls = withContextualAttributeTemplate({
        opportunityId: opportunity.OpportunityId,
        entityName: generatedFrom,
        entityId: _.isNull(opportunity.GoalId) ? undefined : opportunity.GoalId,
        entityType: CONTEXTUAL_ENTITY_TYPE.GENERATED_FROM,
        status: 'false',
        pageUrls: opportunity.PageUrls,
        style: { color: 'black' },
      });
    }

    return template({
      Urls,
    });
  }

  get property() {
    return {
      get: _.identity,
      property: 'GeneratedFrom',
    };
  }
}
